const OPENING_ASSET_BASE = '/assets/opening-presets';

export const OPENING_REVEAL_PRESETS = {
  wedding_favor: {
    image: `${OPENING_ASSET_BASE}/wedding-favor.jpg`,
    label: 'Champagne Favor',
    material: 'Ivory card, sage ribbon, candle glow',
    steps: ['Card', 'Ribbon', 'Blessing'],
  },
  pearl_rose: {
    image: `${OPENING_ASSET_BASE}/mom-keepsake.jpg`,
    label: 'Rose Keepsake',
    material: 'Blush ribbon, soft paper, warm light',
    steps: ['Ribbon', 'Letter', 'Memory'],
  },
  warm_keepsake: {
    image: `${OPENING_ASSET_BASE}/mom-keepsake.jpg`,
    label: 'Rose Keepsake',
    material: 'Blush ribbon, soft paper, warm light',
    steps: ['Ribbon', 'Letter', 'Memory'],
  },
  editorial_romance: {
    image: `${OPENING_ASSET_BASE}/couple-anniversary.jpg`,
    label: 'Private Envelope',
    material: 'Velvet, champagne foil, cinematic light',
    steps: ['Envelope', 'Letter', 'Story'],
  },
  soft_family: {
    image: `${OPENING_ASSET_BASE}/baby-celebration.jpg`,
    label: 'Little Milestone',
    material: 'Pastel cards, cotton, morning light',
    steps: ['Album', 'Milestone', 'Wish'],
  },
  quiet_keepsake: {
    image: `${OPENING_ASSET_BASE}/memorial-legacy.jpg`,
    label: 'Memory Archive',
    material: 'Pearl box, eucalyptus, soft daylight',
    steps: ['Archive', 'Voice', 'Legacy'],
  },
  friends_graduation: {
    image: `${OPENING_ASSET_BASE}/friends-graduation.png`,
    label: 'Polaroid Map',
    material: 'Instant camera, campus map, cream paper',
    steps: ['Booth', 'Map', 'Museum'],
  },
  modern_poster: {
    image: '/assets/lumirae-gift-hero.jpg',
    label: 'Modern Memory',
    material: 'Clean card, bold photo, crisp finish',
    steps: ['Photo', 'Note', 'Card'],
  },
};

export const getOpeningRevealPreset = (themeId) => {
  return OPENING_REVEAL_PRESETS[themeId] ||
    OPENING_REVEAL_PRESETS.pearl_rose;
};
